/** Balance point totals into net owed (dollars) per player key. */
export function balanceNetOwed(playerKeys: string[], points: number[], multiplier: number): Record<string, number> {
  const mean = points.reduce((a, b) => a + b, 0) / points.length;
  const rounded = points.map((p) => Math.round((p - mean) * multiplier * 100));
  let drift = rounded.reduce((a, b) => a + b, 0);
  if (drift !== 0) {
    let idx = 0;
    for (let k = 1; k < rounded.length; k++) {
      if (Math.abs(rounded[k]) > Math.abs(rounded[idx])) idx = k;
    }
    rounded[idx] -= drift;
  }
  const netOwed: Record<string, number> = {};
  playerKeys.forEach((key, k) => { netOwed[key] = rounded[k]; });
  return netOwed;
}
